<p-dialog
	[(visible)]="visible"
	(onHide)="closeDialog()"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[dismissableMask]="false"
	[closable]="true"
	[style]="{ width: 'min(760px, 96vw)' }"
	styleClass="wizard-dialog"
	contentStyleClass="p-0"
>
	<ng-template pTemplate="header">
		<h1 class="h4 m-0 w-100 text-center fw-semibold">Asistente de bienvenida</h1>
	</ng-template>

	<section class="wizard-body px-4 py-3">
		<div class="wizard-media d-flex align-items-center justify-content-center">
			@if (currentStep.imageUrl !== null) {
				<img [src]="currentStep.imageUrl" alt="" class="wizard-image img-fluid rounded-3" />
			}
		</div>

		<div class="wizard-copy mx-auto text-center">
			<h2 class="h4 fw-bold text-body mb-2">
				{{ currentStep.title }}
			</h2>

			<p class="text-secondary mb-0">
				{{ currentStep.subtitle }}
			</p>
		</div>

		<div class="wizard-action mx-auto w-100 text-center">
			@if (isAuthorizationStep) {
				<p-button
					[label]="currentStep.actionLabel"
					icon="pi pi-download"
					severity="info"
					(onClick)="downloadAuthorizationDocument()"
				></p-button>

				<p class="small text-secondary mt-3 mb-1">¿Prefieres que gestionemos la autorización por ti?</p>

				<p class="small text-secondary mb-0">
					Escríbenos a
					<a href="mailto:agrogest@locatec.es">agrogest&#64;locatec.es</a>
					o llama al
					<a href="tel:+34962843032">+34 962 843 032</a>.
				</p>
			}
		</div>

		@if (errorMessage !== '') {
			<div class="alert alert-danger py-2 mb-0" role="alert">
				{{ errorMessage }}
			</div>
		}
	</section>

	<ng-template pTemplate="footer">
		<div class="d-flex w-100 align-items-center justify-content-center gap-2 py-2">
			<p-button
				icon="pi pi-arrow-left"
				severity="secondary"
				[rounded]="true"
				styleClass="wizard-arrow"
				[style.visibility]="isFirstStep ? 'hidden' : 'visible'"
				[attr.tabindex]="isFirstStep ? -1 : null"
				[attr.aria-hidden]="isFirstStep ? true : null"
				aria-label="Volver al paso anterior"
				(onClick)="goToPreviousStep()"
			></p-button>

			<ul class="list-unstyled d-flex align-items-center gap-1 m-0 px-1" aria-label="Progreso">
				@for (step of steps; track step.title; let index = $index) {
					<li
						class="wizard-dot"
						[class.wizard-dot-active]="index === currentStepIndex"
						[attr.aria-current]="index === currentStepIndex ? 'step' : null"
						[attr.aria-label]="'Paso ' + (index + 1) + ' de ' + steps.length"
					></li>
				}
			</ul>

			<p-button
				[icon]="isLastStep ? 'pi pi-check' : 'pi pi-arrow-right'"
				[severity]="isLastStep ? 'success' : 'primary'"
				[rounded]="true"
				[loading]="isSaving"
				[disabled]="!canContinue || isSaving"
				styleClass="wizard-arrow"
				[attr.aria-disabled]="!canContinue || isSaving"
				[attr.aria-label]="isLastStep ? 'Finalizar asistente' : 'Continuar al siguiente paso'"
				(onClick)="goToNextStep()"
			></p-button>
		</div>
	</ng-template>
</p-dialog>
